import { BoxProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { useNavigate } from 'react-router';

import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
// import { ReactComponent as MaximizeIcon } from 'assets/icons/containerActions/maximize.svg';
import { CreateButton } from 'features/kpi/containers/KpiPreview/styled';
import { theme } from 'styles';

import { ContentW, HeaderW, Title } from './styled';

interface PreviewContainerProps {
  title: string;
  buttonTitle?: string;
  handleTitleClick?: () => void;
  addIconLink?: string;
  maximizeIconLink?: string;
  children: ReactNode;
  containerSx?: BoxProps['sx'];
  headerSx?: BoxProps['sx'];
}

export function PreviewContainer({
  title,
  buttonTitle,
  handleTitleClick,
  addIconLink,
  // maximizeIconLink,
  children,
  containerSx,
  headerSx,
}: PreviewContainerProps): ReactElement {
  const navigate = useNavigate();
  return (
    <ContentW sx={containerSx}>
      <HeaderW sx={headerSx}>
        <Title onClick={handleTitleClick} sx={{ cursor: handleTitleClick ? 'pointer' : 'default' }}>
          {title}
        </Title>

        {addIconLink && (
          <CreateButton
            startIcon={<AddIcon style={{ fill: theme.palette.common.white }} />}
            onClick={() => navigate(addIconLink)}
            style={{
              height: '56px',
              padding: '16px',
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
              fontSize: '14px',
              fontWeight: 400,
              borderRadius: '8px',
              textTransform: 'none',
            }}
          >
            {buttonTitle}
          </CreateButton>
        )}
      </HeaderW>

      {children}
    </ContentW>
  );
}
